import { LOCATION_CHANGE } from 'react-router-redux';

import * as D from '../../deps';
import * as ComscoreWorkers from '../workers';

export default [
  {
    actionType: LOCATION_CHANGE,
    handler: ComscoreWorkers.onLocationChange,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.REGISTER_SKIP_TRACK,
    handler: ComscoreWorkers.onSkipTrack,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.TRACK_THUMBDOWN,
    handler: ComscoreWorkers.onThumbDown,
    concur: 'takeEvery',
  },
];
